import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

interface CardProps {
  children: ReactNode;
  className?: string;
  header?: ReactNode;
  footer?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  padding?: boolean;
}

export function Card({ children, className, header, footer, title, subtitle, actions, padding = true }: CardProps) {
  return (
    <section className={cn("rounded-lg border-2 border-background-300 bg-background-50 shadow-sm", className)}>
      {header ? (
        <div className="flex flex-col gap-3 border-b border-background-100 px-4 py-3 rounded-t-lg bg-background-50 sm:flex-row sm:items-center sm:justify-between">
          <div>{header}</div>
        </div>
      ) : title ? (
        <div className="flex flex-col gap-3 border-b border-background-100 px-4 py-3 rounded-t-lg bg-background-50 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-foreground-900">{title}</h3>
            {subtitle ? <p className="mt-0.5 text-xs text-foreground-500">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      <div className={cn(padding && "p-4")}>{children}</div>
      {footer ? <div className="border-t border-background-100 px-4 py-3 rounded-b-lg bg-background-50">{footer}</div> : null}
    </section>
  );
}